import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// ── DebitSecurity Reseller System ──
import DSLogin from './pages/DSLogin';
import DSMasterDashboard from './pages/DSMasterDashboard';
import DSAdminDashboard from './pages/DSAdminDashboard';

// --- পেজ ইমপোর্ট ---
import Login from './pages/Login'; 
import Dashboard from './pages/Dashboard';
import Users from './pages/Users'; 
import MobileBanking from './pages/MobileBanking'; 
import UserMobileBanking from './pages/UserMobileBanking'; 
import ApiKeyManager from './pages/ApiKeyManager'; 
import UserDeviceManager from './pages/UserDeviceManager'; 
import SecurityCodeManager from './pages/SecurityCodeManager'; 
import MasterKeyManager from './pages/MasterKeyManager'; 
import PaymentReceive from './pages/PaymentReceive'; 
import PendingList from './pages/PendingList'; 
import GetSMSManager from './pages/GetSMSManager'; 
import SeenSMSupdate from './pages/SeenSMSupdate'; 
import AppReceive from './pages/AppReceive'; 
import PaymentSend from './pages/PaymentSend'; 
import SMSLogs from './pages/SMSLogs'; 
import AppReceiveUser from './pages/AppReceiveUser'; 
import SMSReceiveUser from './pages/SMSReceiveUser';
import ChangePassword from './pages/ChangePassword'; 
import AddSMSManager from './pages/SMSManager'; 
import ApiLogViewer from './pages/ApiLogViewer';
import DepositMonitor from './pages/DepositMonitor';
import DeviceTransactions from './pages/DeviceTransactions';
import AppTransactionManager from './pages/AppTransaction';
import JobTrackerDashboard from './pages/JobTrackerDashboard';
import AccountTaskManager from './pages/AccountTaskManager';
import NumberCalculator from './pages/NumberCalculator';
import OtpView from './pages/OtpView';
import BotCodeManager from './pages/BotCodeManager';
import AppInstall from './pages/AppInstall';
import CommissionSetting from './pages/CommissionSetting';

// 🔥 (নতুন) যদি TransactionHistory নামে কোনো পেজ বানান, তবে সেটি এখানে ইমপোর্ট করবেন:
// import TransactionHistory from './pages/TransactionHistory'; 

// ==============================================================
// 🔥 Protected Route Component
// ==============================================================
const ProtectedRoute = ({ children, permissionKey, requireMaster }) => {
    const isMainAdmin = localStorage.getItem('isMaster') === 'true';
    let permissions = {};
    
    try {
        permissions = JSON.parse(localStorage.getItem('permissions') || '{}');
    } catch (e) {
        permissions = {};
    }

    if (isMainAdmin) return children;
    // 🔥 যদি requireMaster সত্য হয় এবং ইউজার Master না হয়, তবে তাকে বের করে দেবে
    if (requireMaster) return <Navigate to="/" replace />;
    if (!permissionKey) return children; 
    if (permissions[permissionKey] === true) return children;

    return <Navigate to="/" replace />;
};

function App() {
    const isDsRoute = window.location.pathname.startsWith('/debit_security');
    if (isDsRoute) {
        const path = window.location.pathname;

        // পুরনো system এ master হিসেবে login আছে কিনা
        const oldMaster = localStorage.getItem('isMaster') === 'true' && !!localStorage.getItem('adminId');
        // নতুন system এ login আছে কিনা
        const dsRole = localStorage.getItem('ds_role');
        const dsToken = localStorage.getItem('ds_token');

        // /debit_security/master বা /debit_security/admin এ সরাসরি ঢুকলে
        if (path === '/debit_security/master') {
            return <BrowserRouter><Routes>
                <Route path="/debit_security/master" element={<DSMasterDashboard />} />
            </Routes></BrowserRouter>;
        }
        if (path === '/debit_security/admin') {
            return <BrowserRouter><Routes>
                <Route path="/debit_security/admin" element={<DSAdminDashboard />} />
            </Routes></BrowserRouter>;
        }

        // /debit_security login পেজে আসলে — master আগেই login থাকলে সরাসরি dashboard
        if (oldMaster) {
            window.location.replace('/debit_security/master');
            return null;
        }
        if (dsToken && dsRole === 'master') {
            window.location.replace('/debit_security/master');
            return null;
        }
        if (dsToken && dsRole === 'ds_admin') {
            window.location.replace('/debit_security/admin');
            return null;
        }

        return <BrowserRouter><Routes>
            <Route path="/debit_security" element={<DSLogin />} />
        </Routes></BrowserRouter>;
    }

    const [isAdminLoggedIn] = useState(() => {
        return !!localStorage.getItem('adminId');
    });

    if (!isAdminLoggedIn) {
        return (
            <div className="App">
                <Login />
            </div>
        );
    }

    return (
        <BrowserRouter>
            <Routes>
                {/* --- পাবলিক/কমন পেজ --- */}
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/change_password" element={<ChangePassword />} />

                
                {/* --- মাস্টার এডমিন পেজ --- */}
                <Route path="/users" element={
                    <ProtectedRoute permissionKey="permissonUserlist">
                        <Users />
                    </ProtectedRoute>
                } />

                <Route path="/job_tracker" element={
    <ProtectedRoute permissionKey="permissonJobTracker">
        <JobTrackerDashboard />
    </ProtectedRoute>
} />

 <Route path="/NumberCalculator" element={<NumberCalculator />} />

<Route path="/account_tasks" element={
    <ProtectedRoute permissionKey="permissonAccount">
        <AccountTaskManager />
    </ProtectedRoute>
} />

<Route path="/device-setup" element={<AppInstall />} />

  <Route path="/bot_codes" element={
                    <ProtectedRoute requireMaster={true}>
                        <BotCodeManager />
                    </ProtectedRoute>
                } />


<Route path="/otp_view" element={
                    <ProtectedRoute requireMaster={true}>
                        <OtpView />
                    </ProtectedRoute>
                } />
                

                <Route path="/user_devices" element={
                      <ProtectedRoute permissionKey="permissonUserdevices">
                        <UserDeviceManager />
                    </ProtectedRoute>
                } />
                
                {/* 🔥 আপডেটেড রাউট: Master অথবা permissonUserdevices থাকলে এক্সেস পাবে */}
                <Route path="/device-transactions" element={
                    <ProtectedRoute permissionKey="permissonTransactionHistory">
                        <DeviceTransactions />
                    </ProtectedRoute>
                } />


                {/* Debit Security রাউট App() এর শুরুতে isDsRoute দিয়ে হ্যান্ডল হয় (DSLogin/DSMasterDashboard) */}

                {/* --- ইউজার পেজ --- */}
                <Route path="/appreceive_user" element={<AppReceiveUser />} />
                <Route path="/sms_receive_user" element={<SMSReceiveUser />} />
                <Route path="/sms_user" element={<SMSLogs />} />
                
                {/* 🔥 নতুন ১: User Mobile Banking রাউটটিকে প্রোটেক্ট করা হলো */}
                <Route path="/user_mobile_banking" element={
                    <ProtectedRoute permissionKey="permissonUserMobileBank">
                        <UserMobileBanking />
                    </ProtectedRoute>
                } />

                {/* 🔥 নতুন ২: Transaction History রাউট (পেজ বানালে কমেন্ট তুলে দিবেন) */}
                {/* <Route path="/transaction_history" element={
                    <ProtectedRoute permissionKey="permissonTransactionHistory">
                        <TransactionHistory />
                    </ProtectedRoute>
                } /> 
                */}

                {/* --- প্রোটেক্টেড পেজ --- */}
                <Route path="/payment_receive" element={
                    <ProtectedRoute permissionKey="permissonPaymentReceived">
                        <PaymentReceive />
                    </ProtectedRoute>
                } />

                <Route path="/mobile_banking" element={
                    <ProtectedRoute permissionKey="permissonMobileBank">
                        <MobileBanking />
                    </ProtectedRoute>
                } />

                <Route path="/payment_send" element={
                        <PaymentSend />
                } />
                
                <Route path="/pending_list" element={
                    <ProtectedRoute permissionKey="permissonSendPayment">
                        <PendingList />
                    </ProtectedRoute>
                } />

                <Route path="/smsget" element={
                    <ProtectedRoute permissionKey="permissonGetsms">
                        <GetSMSManager />
                    </ProtectedRoute>
                } />
                
                <Route path="/sms" element={
                    <ProtectedRoute permissionKey="permissonAddsms">
                        <AddSMSManager />
                    </ProtectedRoute>
                } />

                <Route path="/app_receive" element={
                    <ProtectedRoute permissionKey="permissonAPPreceive">
                        <AppReceive />
                    </ProtectedRoute>
                } />

                <Route path="/api_keys" element={
                    <ProtectedRoute permissionKey="permissonAPIkey">
                        <ApiKeyManager />
                    </ProtectedRoute>
                } />

                <Route path="/codes" element={
                    <ProtectedRoute permissionKey="permissonCode">
                        <SecurityCodeManager />
                    </ProtectedRoute>
                } />

                <Route path="/update_seen" element={
                    <ProtectedRoute permissionKey="permissonSeenBy">
                        <SeenSMSupdate />
                    </ProtectedRoute>
                } />

                {/* --- ONLY MASTER ADMIN PAGES --- */}
                <Route path="/master_keys" element={
                    <ProtectedRoute requireMaster={true}>
                        <MasterKeyManager />
                    </ProtectedRoute>
                } />

                      <Route path="/api_logs" element={
                      <ProtectedRoute permissionKey="permissonApiview">
                      <ApiLogViewer />
                    </ProtectedRoute>
                } />
                
                
                <Route path="/deposit_monitor" element={
                    <ProtectedRoute requireMaster={true}>
                      <DepositMonitor />
                    </ProtectedRoute>
                } />

                <Route path="/app_transactions" element={
                    <ProtectedRoute permissionKey="apptransactionscheck"> 
                        <AppTransactionManager />
                    </ProtectedRoute>
                } />

                <Route path="/commission_setting" element={
                    <ProtectedRoute requireMaster={true}>
                        <CommissionSetting />
                    </ProtectedRoute>
                } />

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;